import { render, staticRenderFns } from "./teoriakoulutukset.vue?vue&type=template&id=500cbdc9&scoped=true&"
import script from "./teoriakoulutukset.vue?vue&type=script&lang=ts&"
export * from "./teoriakoulutukset.vue?vue&type=script&lang=ts&"
import style0 from "./teoriakoulutukset.vue?vue&type=style&index=0&id=500cbdc9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500cbdc9",
  null
  
)

export default component.exports